import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-duplicar-feriados-dialog',
  templateUrl: './duplicar-feriados-dialog.component.html',
  styleUrls: ['./duplicar-feriados-dialog.component.css']
})
export class DuplicarFeriadosDialogComponent {
  anioOrigen: number = new Date().getFullYear();
  anioDestino: number = new Date().getFullYear();

  constructor(
    public dialogRef: MatDialogRef<DuplicarFeriadosDialogComponent>
  ) {}

  onCancelar(): void {
    this.dialogRef.close();
  }

  onDuplicar(): void {
    this.dialogRef.close({ origen: this.anioOrigen, destino: this.anioDestino });
  }
}
